import cookieToMap from './cookieToMap';

export default cookieToMap;
